import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import router from '@/router'
import 'ant-design-vue/dist/antd.less';
import '@/assets/style.css';
import '@/commom/initial'
Vue.config.productionTip = false

Vue.use(Antd)

window.setFilePath = function (path) {
  return path ? (window._file_service + path) : "";
}
Vue.filter("filePath", window.setFilePath);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')